module.exports = __webpack_public_path__ + "static/img/underReview.c0ef894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/underReview.png
// module id = tLSU
// module chunks = 6